import React from 'react';
import { message as antd_message, Modal as antd_Modal, Menu } from 'antd';
import moment_lib from 'moment';
import { FetchHelper as fh } from "@yulintu/freesia-core";
import { Accessor } from "@yulintu/freesia-bootstrap";

import { SvgIconText } from 'freesia-ui';

import { getRandomColor } from "../utils/predefine-color";
import { parseResultToJson as parseResultToJsonHelper } from '../utils/helper';
import _loadjs from '../utils/loadjs';
// import _sm4 from '../utils/sm4';

import PropertyDescriptor from "./PropertyDescriptor";

import ModelRefProperty from "../diagrams/ModelRefProperty";
import BaseModel from "../diagrams/Model";

export default class DiagramUtils {

    static diagrams = {};

    static register(modelType, modelInfo) {
        DiagramUtils.diagrams[modelType] = {
            ...modelInfo,
            createModel: () => {
                let m = typeof modelInfo.model;
                if (m !== "string")
                    return new modelInfo.model();

                m = JSON.parse(modelInfo.model);
                const diagrams = DiagramUtils.diagrams;
                const info = diagrams[m.type];
                let model = new info.model(m.model);
                model.setRandomId();
                return model;
            }
        };
    }

    static getModelTypeName(modelType) {
        let modeInfo = DiagramUtils.diagrams[modelType];
        return modeInfo ? modeInfo.alias : "未知";
    }

    static getModelMetadata(modelType) {
        let modeInfo = DiagramUtils.diagrams[modelType];
        return modeInfo;
    }

    static runScript(mainModel, script, customDataContext, customModel, args, opts) {

        if (!script)
            return;

        const me = mainModel._sys.ui;
        const dataModel = customModel || mainModel;
        const dataContext = (customDataContext !== null && customDataContext !== undefined) ? customDataContext : dataModel.getDataContext();
        const run = function () {
            try {
                const model = dataModel;
                const designer = mainModel._sys.designer;
                const global = designer.props.data;
                let data = dataContext;
                const getData = () => dataModel.getDataContext();
                const getParentData = () => dataModel.getParentDataContext();
                const getInternalData = () => dataModel.getInternalDataContext();
                const getOutterData = () => designer.paper.getDataContext();
                const ui = me;
                const createModel = DiagramUtils.createModel.bind(me);
                const diagram = createModel;
                const template = id => DiagramUtils.createModelByTemplate(designer, id);
                const listenDataChanged = (name, listener) => {
                    if (!ui)
                        throw new Error("部件未加载，无法订阅消息");
                    ui && ui.listenDataChanged(name, listener);
                }
                const received = listenDataChanged;
                const on = listenDataChanged;
                const dataChanged = designer.raiseDataChanged.bind(designer);
                const send = dataChanged;
                const dispatch = dataChanged;
                const accessor = () => new Accessor();
                const FetchHelper = fh;
                const get = FetchHelper.getJson.bind(FetchHelper);
                const post = FetchHelper.postJson.bind(FetchHelper);
                const put = FetchHelper.putJson.bind(FetchHelper);
                const del = FetchHelper.deleteJson.bind(FetchHelper);
                const dom = model._sys.dom;
                const moment = moment_lib;
                const parseResultToJson = parseResultToJsonHelper;
                const randomColor = getRandomColor;

                const message = antd_message;
                const Modal = antd_Modal;

                const loadjs = _loadjs;

                // const sm4 = _sm4;

                const result = eval(script);
                return result;
            }
            catch (err) {
                console.error(script);
                console.error(err);
                if (opts && opts.throwException)
                    throw err;
            }
        }

        const context = {
            ...mainModel._args,
            ...args,
        };

        context.refs = mainModel.dataContext.refs.map(c => c.enabled ? c._sys.ref : null);
        mainModel.dataContext.refs.forEach(c => c.enabled && c.name && (context[c.name] = c._sys.ref));

        return run.bind(context)();
    }

    static createModel(type) {
        const diagrams = DiagramUtils.diagrams;
        const modelInfo = diagrams[type];
        const m = modelInfo.createModel();
        m.layoutMode = "flex";
        m._sys.temp = true;
        return m;
    }

    static createModelByTemplate(designer, id) {
        const json = designer.templates[id];
        if (!json)
            return null;

        const m = designer.createModelByModel(json);
        m.setRandomId();
        m._sys.temp = true;
        return m;
    }

    static property_template(alias, catalog, opts) {
        return new PropertyDescriptor([], alias, catalog, "objects", "#anticon-commonfunction", {
            visible: false,
            max: 1,
            clickAdd: false,
            clickEnter: false,
            droppable: true,
            droppableText: "从页面结构拖拽一个控件到此处作为模板",
            droppableDataType: "diagram-ref-id",

            showMenuUp: false,
            showMenuDown: false,

            showMenuCopy: false,
            showMenuPaste: false,

            menuExtraBeforeGetter: (i, item) => {
                return [
                    <Menu.Item key="refresh" onClick={e => item.refresh()}><SvgIconText spacing='md' type='#anticon-shuaxin' text='刷新' /></Menu.Item>
                ]
            },

            // itemDraggable: true,
            // itemDraggableDataType: "diagram-echartsv4-serie",

            modelTemplate: ModelRefProperty,
            modelGetterOnDrop: (args, owner) => {
                console.log(args);

                const model = owner.getParentByType(BaseModel);
                const designer = model._sys.designer;
                const ref = designer.findById(args);
                if (!ref)
                    return;

                const r = new ModelRefProperty();
                r.fromModel(ref);

                return r;
            },
            ...opts,
        });
    }
}